import $ from 'jquery';
import service from '../ajax/service';
import * as swiper from './swiper';
const isPhone = window.platform.isPhone();
const banID = '6986';
const guideTypeAll = '1519,1520,1521,1522';
const articleTypeList = '1517,1518';
const activityType = '1517';
const noticeType = '1518';
const baseArticleLink =
  'https://www.blancozone.com/frxx/detail.html';
const showNum = isPhone ? 3 : 4;
const getArticleHtml = data => {
  let html = '';
  data.forEach(item => {
    html += isPhone
      ? `
           <a href="${baseArticleLink}?id=${item.ID}&ids=${
          item.ARTICLE_TYPE_ID
        }" target="_blank" class="news-item">
              <span class="left">${item.TITLE}</span>
              <span class="list-line"></span>
              <span class="right">${item.PUBLISH_TIME.slice(5, 10)}</span>
           </a>`
      : `<a href="${baseArticleLink}?id=${item.ID}&ids=${
          item.ARTICLE_TYPE_ID
        }" target="_blank" class="news-item">
                  <span>${item.PUBLISH_TIME.slice(5, 10)}</span>
                  <span class="item-title">${item.TITLE}</span>
                  <span class="desc">${item.SHORT_TITLE}</span>
              </a>`;
  });
  return html;
};
service.getArticleList(articleTypeList).then(res => {
  const allArticles = res.data.filter(item => +item.ID !== +banID);
  const articleSlides = allArticles.filter(item => +item.ORDER_INDEX === 2);
  const activityArticles = allArticles.filter(
    item => +item.ARTICLE_TYPE_ID === +activityType
  );
  const noticeArticles = allArticles.filter(
    item => +item.ARTICLE_TYPE_ID === +noticeType
  );
  let html = '';
  if (articleSlides.length) {
    articleSlides.forEach(item => {
      html += `                   
                   <div class="swiper-slide">
                          <a class="news-img" target="_blank" href="${baseArticleLink}?id=${item.ID}&ids=${item.ARTICLE_TYPE_ID}" style="background-image: url('${item.PIC}')"></a>
                  </div>`;
    });
    $('.j-newsPic-wrapper').html(html);
  }
  $('.j-news-all').html(getArticleHtml(allArticles.slice(0, showNum)));
  $('.j-news-activity').html(getArticleHtml(activityArticles.slice(0, showNum)));
  $('.j-news-notice').html(getArticleHtml(noticeArticles.slice(0, showNum)));
  swiper.initNews();
});
service.getArticleList(guideTypeAll).then(res => {
  const allGuideArticles = res.data.slice(0, 3);
  let html = '';
  if (allGuideArticles.length) {
    allGuideArticles.forEach(item => {
      html += `                   
             <a href="${baseArticleLink}?id=${item.ID}&ids=${
        item.ARTICLE_TYPE_ID
      }" target="_blank" class="item">
                  <span class="left">${item.TITLE}</span>
                  <span class="list-line"></span>
                  <span class="right">${item.PUBLISH_TIME.slice(5, 10)}</span>
             </a>`;
    });
  }
  $('.j-guide-list').html(html);
});
